import { useContext, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import { REPORT_SUITE_QUESTIONS } from '../../config/collectionHomes';
// @ts-expect-error Untyped import
import { trackEvent, EVENTS } from '../../lib/usageTracker';
import SideNavReRenderContext from '../../records/SideNavReRenderContext';
// @ts-expect-error Untyped import
import QuickAnswers from '../../components/analyticsSuites/QuickAnswers';
import AnalyticsSuitesSideWidget from '../../components/common/AnalyticsSuitesSideWidget';
// @ts-expect-error Untyped import
import DescriptiveReportsCardsGrid from '../../components/analyticsSuites/DescriptiveReportsCardsGrid';
import RecentlyViewedTemplatesSection from '../../components/analyticsSuites/RecentlyViewedTemplatesSection';
import TemplateRecommendationSection from '../../components/analyticsSuites/TemplateRecommendationSection';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AnalyticsSuite = ({
  collectionId,
  reports,
  feedbackClient
}) => {
  const history = useHistory();
  const {
    sideNavReRender,
    updateSideNavReRender
  } = useContext(SideNavReRenderContext);
  const suiteQuestions = REPORT_SUITE_QUESTIONS[collectionId];
  const handleClickQuestions = useCallback(({
    question
  }) => {
    trackEvent(EVENTS.clickPopularQuestion, {
      source: question.questionId,
      interactionSource: collectionId
    });
    updateSideNavReRender(!sideNavReRender);
    history.push({
      pathname: question.path,
      search: `?question=${question.questionId}`
    });
  }, [history, collectionId, sideNavReRender, updateSideNavReRender]);
  const renderQuickAnswerSection = () => {
    return /*#__PURE__*/_jsx(QuickAnswers, {
      questions: suiteQuestions,
      onClickCallBack: handleClickQuestions
    });
  };
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "ANALYTICS_SUITE_HOME_CONTAINER",
    children: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs(View, {
        marginBlockEnd: "500",
        as: "div",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h3",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `reports.collectionHomes.headers.${collectionId}`
          })
        }), /*#__PURE__*/_jsx(Text, {
          as: "small",
          color: "text-core-subtle",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `reports.collectionHomes.welcome.${collectionId}`
          })
        })]
      }), renderQuickAnswerSection(), /*#__PURE__*/_jsxs(TFlex, {
        align: "start",
        justify: "start",
        gap: 24,
        direction: "row",
        children: [/*#__PURE__*/_jsxs(Box, {
          grow: 1,
          children: [/*#__PURE__*/_jsx(RecentlyViewedTemplatesSection, {
            suiteId: collectionId,
            collectionId: collectionId
          }), /*#__PURE__*/_jsx(TemplateRecommendationSection, {
            suiteId: collectionId
          }), /*#__PURE__*/_jsx(DescriptiveReportsCardsGrid, {
            reports: reports
          })]
        }), /*#__PURE__*/_jsx(AnalyticsSuitesSideWidget, {
          feedbackClient: feedbackClient,
          suiteId: collectionId
        })]
      })]
    })
  });
};
export default AnalyticsSuite;